const GET_BULK_ORDER_BY_ID = "GET_BULK_ORDER_BY_ID"
const SET_BULK_ORDER_BY_ID = "SET_BULK_ORDER_BY_ID"

export{
    GET_BULK_ORDER_BY_ID,
    SET_BULK_ORDER_BY_ID
}